/**
 * Read query params WITHOUT useSearchParams().
 *
 * Next requires any component calling useSearchParams() to sit inside a
 * Suspense boundary, and that boundary is excluded from the static shell. With
 * `fallback={null}` the server rendered NOTHING for those subtrees: /pricing,
 * /free-vc-list and /pitch-deck-templates each served ~55 visible words (nav
 * and footer only). No AI crawler executes JavaScript, so the three most
 * commercial pages on the site were invisible to them.
 *
 * All three only ever read params inside effects or submit handlers — never to
 * decide the initial render — so reading window.location.search directly is
 * equivalent, and lets the whole page prerender.
 *
 * Returns null on the server, matching URLSearchParams.get() for a missing key.
 */
export function getQueryParam(name: string): string | null {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search).get(name);
}
